@if(!isLoading) {
<div class="container">
  <div *ngIf="!isLoading">
    <div style="max-width: 1024px; text-align: left; width: 100%">

      <!-- View Mode Toggle -->
      <div class="view-mode-toggle">
        <button mat-icon-button [class.active]="viewMode() === 'list'" (click)="viewModeService.setViewMode('list')"
          matTooltip="Visualização em Lista" aria-label="Modo de visualização em lista">
          <mat-icon>view_list</mat-icon>
        </button>
        <button mat-icon-button [class.active]="viewMode() === 'grid'" (click)="viewModeService.setViewMode('grid')"
          matTooltip="Visualização em Grade" aria-label="Modo de visualização em grade">
          <mat-icon>view_module</mat-icon>
        </button>

        <!-- Export Button -->
        <button mat-raised-button color="accent" (click)="openExportDialog()" [disabled]="!items || items.length === 0"
          class="export-button" matTooltip="Exportar resultados" aria-label="Exportar resultados da busca">
          <mat-icon>file_download</mat-icon>
          Exportar
        </button>
      </div>

      <!-- Floating Compare Button -->
      @if (canCompare()) {
      <div class="compare-fab-container">
        <button mat-fab extended color="primary" (click)="openComparison()" class="compare-fab"
          aria-label="Comparar itens selecionados">
          <mat-icon>compare_arrows</mat-icon>
          Comparar ({{ comparisonCount() }})
        </button>
        <button mat-mini-fab color="warn" (click)="clearComparison()" class="clear-fab" matTooltip="Limpar seleção"
          aria-label="Limpar seleção de comparação">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
      }

      <!-- List View (Accordion) -->
      @if (viewMode() === 'list') {
      <mat-accordion>
        <mat-expansion-panel *ngFor="let item of pagedItems ; let i = index" (opened)="panelOpenState.set(true)"
          (closed)="panelOpenState.set(false)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="comparison-checkbox-container">
                <mat-checkbox [checked]="isItemSelected(item.id)" (change)="toggleItemSelection(item, $event)"
                  [disabled]="isFull() && !isItemSelected(item.id)"
                  [matTooltip]="isFull() && !isItemSelected(item.id) ? 'Limite de comparação atingido (máximo 4 itens)' : 'Selecionar para comparação'"
                  aria-label="Selecionar item para comparação">
                </mat-checkbox>
              </div>
              <div class="mat-panel-title-custom">

                {{ item.id }} -
                <strong class="field-value">
                  {{ getResourcesDescription(item.resource) }}
                </strong>
              </div>
              <div class="observationText">
                <div>
                  <ng-container *ngIf="item.publicationDate; else notPublished">
                    Data da Publicação: {{ item.publicationDate | date:'dd/MM/yyyy' }}
                    <span *ngIf="item.expirationPublicationDate">
                      - Valido até: {{ item.expirationPublicationDate | date:'dd/MM/yyyy' }}
                    </span>
                  </ng-container>
                  <ng-template #notPublished>Não Publicado</ng-template>
                </div>
                <div style="flex: 1 0 50px; place-self: self-end">
                  {{ item.status! | enumDescription }}
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-panel-description style="flex-wrap: wrap">
            <!-- exames e terapias agrupados por categorias -->
            <div class="resources-container">
              <ng-container *ngIf="getResourceGroups(item.resource) as resourceGroups">
                <!-- Seção de Exames -->
                <ng-container *ngIf="resourceGroups.exames.length > 0">
                  <div class="resource-category">
                    <h3>EXAMES</h3>
                    <div class="resource-list">
                      <span *ngFor="let exame of resourceGroups.exames; let last = last" class="resource-item">
                        {{ exame.description }}{{ !last ? ';' : '' }}
                      </span>
                    </div>
                  </div>
                </ng-container>

                <!-- Seção de Terapias -->
                <ng-container *ngIf="resourceGroups.terapias.length > 0">
                  <div class="resource-category">
                    <h3>TERAPIAS</h3>
                    <div class="resource-list">
                      <span *ngFor="let terapia of resourceGroups.terapias; let last = last" class="resource-item">
                        {{ terapia.description }}{{ !last ? ';' : '' }}
                      </span>
                    </div>
                  </div>
                </ng-container>

              </ng-container>
            </div>

            <br />

            <div class="field-row">
              <span>Data da criação:</span>
              <span class="field-dots"></span>
              <strong class="field-value">{{ item.creationDate | date:'dd/MM/yyyy - hh:mm' }}</strong>
            </div>

            <div class="field-row">
              <span>Endereço:</span>
              <span class="field-dots"></span>
              <strong class="field-value">
                @if(item.address?.street) {
                {{ item.address?.street }}, {{ item.address?.number }} -
                {{ item.address?.city }}/{{ item.address?.state }}}
              </strong>
            </div>

            <div>
              Disponibilidade:
              <app-availability [availabilityShow]="item.availability"></app-availability>
            </div>


            <div class="footerButtons">
              <div class="panel-footer">
                <div class="actions">
                  <button mat-raised-button color="primary" (click)="createRegisterNegotiation(item.id)  ">
                    <mat-icon>speaker_notes</mat-icon>
                    <span>Convidar para negociar</span>
                  </button>
                </div>
              </div>
            </div>
          </mat-panel-description>
        </mat-expansion-panel>
      </mat-accordion>
      }

      <!-- Grid View -->
      @if (viewMode() === 'grid') {
      <div class="grid-container">
        <mat-card *ngFor="let item of pagedItems" class="result-card"
          [class.selected-for-comparison]="isItemSelected(item.id)">
          <div class="card-checkbox">
            <mat-checkbox [checked]="isItemSelected(item.id)" (change)="toggleItemSelection(item, $event)"
              [disabled]="isFull() && !isItemSelected(item.id)"
              [matTooltip]="isFull() && !isItemSelected(item.id) ? 'Limite de comparação atingido (máximo 4 itens)' : 'Selecionar para comparação'"
              aria-label="Selecionar item para comparação">
            </mat-checkbox>
          </div>
          <mat-card-header>
            <mat-card-title>
              <div class="card-title-text">
                {{ item.id }} - {{ getResourcesDescription(item.resource) }}
              </div>
            </mat-card-title>
          </mat-card-header>

          <mat-card-content>
            <!-- Resources grouped by category -->
            <div class="card-resources" *ngIf="getResourceGroups(item.resource) as resourceGroups">
              <ng-container *ngIf="resourceGroups.exames.length > 0">
                <div class="resource-section">
                  <div class="resource-section-title">
                    <mat-icon class="field-icon">science</mat-icon>
                    <strong>Exames</strong>
                  </div>
                  <div class="resource-chips">
                    <mat-chip *ngFor="let exame of resourceGroups.exames">
                      {{ exame.description }}
                    </mat-chip>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="resourceGroups.terapias.length > 0">
                <div class="resource-section">
                  <div class="resource-section-title">
                    <mat-icon class="field-icon">healing</mat-icon>
                    <strong>Terapias</strong>
                  </div>
                  <div class="resource-chips">
                    <mat-chip *ngFor="let terapia of resourceGroups.terapias">
                      {{ terapia.description }}
                    </mat-chip>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="card-field" *ngIf="item.address?.street">
              <mat-icon class="field-icon">location_on</mat-icon>
              <span>{{ item.address?.city }}/{{ item.address?.state }}</span>
            </div>

            <div class="card-field">
              <mat-icon class="field-icon">calendar_today</mat-icon>
              <span>{{ item.creationDate | date:'dd/MM/yyyy' }}</span>
            </div>

            <div class="card-status">
              <mat-chip>{{ item.status! | enumDescription }}</mat-chip>
            </div>
          </mat-card-content>

          <mat-card-actions>
            <button mat-raised-button color="primary" (click)="createRegisterNegotiation(item.id)">
              <mat-icon>speaker_notes</mat-icon>
              <span>Negociar</span>
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
      }

      <div *ngIf="(!pagedItems || pagedItems.length === 0) && (items && items.length === 0)">
        <p>Nenhum resultado encontrado.</p>
      </div>

      <mat-paginator [length]="length || (items ? items.length : 0)" [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  </div>
</div>
}